<template>
  <div>
    <template v-if="type === 'msku'">商品标题/MSKU</template>
    <template v-if="type === 'asin'">商品标题/ASIN</template>
    <template v-if="type === 'variationAsin'">商品标题/父ASIN</template>
  </div>
</template>

<script>
  export default {
    name: "app-dashboard-rank-product-header",
    props: {
      type: {
        required: true
      }
    }
  }
</script>

<style scoped>

</style>
